import { atom } from 'jotai'

export const isProviderNetworkUnsupportedAtom = atom<boolean | null>(null)
